/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { ConnectionSettings } from '@microsoft/agents-copilotstudio-client'

// Flag to enable debug mode, which will store the debug information in localStorage.
// Copilot Studio Client uses the "debug" library for logging (https://github.com/debug-js/debug?tab=readme-ov-file#browser-support).
window.localStorage.debug = 'copilot-studio:*'

// The CopilotBridge token endpoint, NOT Copilot Studio's public one (that endpoint is closed
// by "Require secured access"). The bridge opens the encrypted request the desktop host built (the
// user's External ID access token, or the anonymous session's device data, plus a timestamp), then
// returns a Direct Line token plus the Direct Line domain to connect to.
//
// Test bridge by default -- matches local dev and `dev`-branch builds. The production build
// pipeline (main branch only) replaces this string with the production bridge URL post-build;
// see azure-devops-pipeline.yml's "Point build at Production" step. That step's variables
// (SANDBOX_TOKEN_ENDPOINT / PRODUCTION_TOKEN_ENDPOINT) must hold the matching bridge URLs
// before this client is released to Production, otherwise the build step fails on purpose.
export class VirtualSurveyorConnectionSettings extends ConnectionSettings {
  constructor () {
    super({
      tokenEndpoint: 'https://test-virtualsurveyor-copilot-bridge.azurewebsites.net/api/token'
    })
  }
}